import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
  useTheme,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  selectUser,
  toggleLoginDialog,
  toggleRegisterDialog,
} from "../../Store/Slices/userSlice";
import useMediaQuery from "@mui/material/useMediaQuery";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import SignUpForm from "./SignUpForm";


const SignUpDialog = () => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  
    const { isRegisterDialogOpen } = useSelector(selectUser);
    const dispatch = useDispatch();
  
    const handleClose = () => {
      dispatch(toggleRegisterDialog());
    };
  
    const handleCreateAccountClick = () => {
      handleClose();
      dispatch(toggleLoginDialog());
    };
  
    const handleSuccess = () => {
      handleCreateAccountClick();
    };
  
    return (
      <Dialog
        fullScreen={fullScreen}
        fullWidth
        style={{ padding: "1rem" }}
        open={isRegisterDialogOpen}
        onClose={handleClose}
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "500px", // Set your width here
              minWidth: "300px"
            },
          },
        }}
      >
        <DialogTitle style={{ textAlign: "center" }}>Sign Up
        <Button
            onClick={handleClose}
            style={{ position: "absolute", right: "8px", top: "8px" }}
            aria-label="Sign Up"
          >
            <CloseIcon />
          </Button></DialogTitle>
        <DialogContent>
          <Typography variant="body1" style={{ textAlign: "left", color: "red" , marginLeft:'15px' }}>
          Please fill in the &lsquo;*&rsquo; marked details for sure.
          </Typography>
          <SignUpForm onSuccess={handleSuccess} />
          <Divider >OR</Divider>
          <Button
            // className={styles.formItem}
            color="secondary"
            fullWidth
            onClick={handleCreateAccountClick}
            aria-label="Sign In instead"
          >
            Already have an account?
          </Button>
        </DialogContent>
      </Dialog>
    );
  };
  
  export default SignUpDialog;
  